<template>
  <dialog-frame :title="$t('registration-mail-error-dialog.title').toString()"
                icon="error_outline"
                color="error"
                closable
                @close="close">
    <template v-slot:content>
      <span v-html="$t('registration-mail-error-dialog.text')"/>
    </template>

    <template v-slot:actions>
      <v-btn plain block
             color="error"
             class="font-weight-bold d-block"
             @click="close">
        {{ $t('app.go-back') }}
      </v-btn>
    </template>
  </dialog-frame>
</template>

<script>

import DialogFrame from "@/templates/dialogs/DialogFrame";
export default {
  name: 'RegistrationMailErrorDialog',

  components: {
    DialogFrame
  },

  methods: {
    close() {
      this.$root.bisadialog.toggle('registrationMailError', false)
    }
  }

};
</script>

